/* Reposition the app's existing controls without replacing its storage or click handlers. */
(() => {
  const controlSelector = 'button, a, [role="button"]';
  const isWishlistControl = (element) => {
    const name = [element.getAttribute('aria-label'), element.getAttribute('title'),
      element.textContent, element.id, element.className,
      element.parentElement?.className].join(' ');
    return /wishlist|wish-list|favorit|lista de desejos|wsb[-_]?heart/i.test(name);
  };
  const findControl = (root) => Array.from(root?.querySelectorAll(controlSelector) || [])
    .find(element => !element.closest('.pdp-detail-panel, .jdgm-widget, .product-recommendations') && isWishlistControl(element));
  const place = (control, host, className) => {
    if (!control || !host || control === host || control.contains(host)) return;
    control.classList.add(className);
    if (control.parentElement !== host) host.append(control);
  };
  function update() {
    document.querySelectorAll('.header__icons').forEach(header => {
      const host = header.querySelector('[data-wishlist-header-slot]');
      const control = findControl(header);
      place(control, host, 'homedock-wishlist-header');
    });
    document.querySelectorAll('.product-detail-refined').forEach(product => {
      const badges = product.querySelector('.product__badges');
      const info = product.querySelector('.product__info-container');
      const control = findControl(info);
      // A link to the wishlist page is navigation, not the add/remove action.
      if (control && !(control.tagName === 'A' && /wishlist/.test(control.getAttribute('href') || ''))) {
        place(control, badges, 'pdp-favorite-action');
      }
      const gallery = product.querySelector('.main-gallery');
      place(findControl(gallery) || findControl(product.querySelector('.product__media-gallery')),
        gallery?.querySelector('.pdp-image-tools'), 'homedock-wishlist-glass');
    });
    document.querySelectorAll('.product-card-wrapper').forEach(wrapper => {
      const card = wrapper.querySelector('.card__inner');
      if (!card) return;
      const control = findControl(card) || findControl(wrapper);
      if (!control) return;
      let host = card.querySelector('.badge-group--right');
      if (!host) {
        host = document.createElement('div');
        host.className = 'homedock-card-tools';
        card.append(host);
      }
      place(control, host, 'homedock-wishlist-glass');
    });
  }
  const observationOptions = { childList: true, subtree: true };
  let updateScheduled = false;
  const observer = new MutationObserver(records => {
    const hasNewControl = records.some(record => Array.from(record.addedNodes).some(node => {
      if (node.nodeType !== Node.ELEMENT_NODE) return false;
      return (node.matches(controlSelector) && isWishlistControl(node)) || Boolean(findControl(node));
    }));
    if (!hasNewControl || updateScheduled) return;
    updateScheduled = true;
    requestAnimationFrame(() => {
      updateScheduled = false;
      // Batch app insertions once per frame. Ignore our own moves to avoid a feedback loop.
      observer.disconnect();
      try {
        update();
      } finally {
        observer.observe(document.body, observationOptions);
      }
    });
  });
  function start() {
    update();
    observer.observe(document.body, observationOptions);
  }
  if (!document.body) document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
